<template>
  <div>
      <div class="uk-section uk-section-default uk-background-legible uk-background-cover uk-background-fixed uk-background-blend-multiply uk-padding-large hero" v-bind:style="{ backgroundImage: `url(${page.bgImage})`}">
          <div class="uk-grid uk-margin-xlarge-top" uk-grid>
              <div class="uk-light uk-width-1-2@l uk-width-3-5@m uk-width-1-1@xs uk-margin-xlarge-bottom">

                  <label>STUDENT COMPETITIONS</label>
                  <h1>Overview</h1>

                  <p class="uk-text-lead" v-html="readPageByURL.summary"></p>

            </div>
          </div>
      </div>

      <FloatingBadge text="Over 1 million students reached worldwide" badgeClass="background-yellow"/>

      <div class="uk-section uk-section-medium uk-background-darkest uk-text-center uk-light">
          <h2>Students Discovering and Celebrating Unsung Heroes</h2>
      </div>

      <div class="uk-section uk-padding-remove-vertical	" v-if="!!readCompetitions.length">
          <div class="uk-grid-collapse" uk-grid>
              <div class="uk-width-1-2@m">
                  <router-link :to="readCompetitions[0].node.link" class="clean">
                      <div class="ar16x9 uk-background-cover placeholder" v-bind:style="{ backgroundImage: `url(${readCompetitions[0].node.image.medium})` }"></div>
                      <div class="uk-alert uk-margin-remove  uk-padding uk-text-center background-darkest uk-light">
                          <h2>{{readCompetitions[0].node.title}}</h2>
                          <span class="uk-button theme-button button-yellow">View Competition</span>
                      </div>
                  </router-link>
              </div>
              <div class="uk-width-1-2@m">
                  <router-link :to="readCompetitions[1].node.link" class="clean">
                      <div class="ar16x9 uk-background-cover placeholder" v-bind:style="{ backgroundImage: `url(${readCompetitions[1].node.image.medium})` }"></div>
                      <div class="uk-alert uk-margin-remove uk-padding  uk-text-center background-yellow">
                          <h2>{{readCompetitions[1].node.title}}</h2>
                          <span class="uk-button theme-button button-dark">View Competition</span>
                      </div>
                  </router-link>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'

// Competition data
const readCompetitionsQuery = gql`{
  readCompetitions {
    edges {
      node {
        title
        link
        image {
            medium
        }
        heroImage {
            large
        }
      }
    }
  }
}`

// Page data
const readPageQuery = gql`
    query($url: String!) {
      readOnePage(filter: { fullPath: { eq: $url }}){
        title
        summary
        content
        link
      }
    }
`

export default {
    data() {
        return {
            page: {
                content: "The Lowell Milken Center for Unsung Heroes offers two project-based learning competitions open to students who wish to celebrate Unsung Heroes. Both competitions offer cash prizes and exciting opportunities for students!",
                bgImage: '/assets/static/competitions.jpg'
            },
            readCompetitions: [],
            readPageByURL: {}
        }
    },
    inject: ['state'],
    beforeRouteEnter (to, from, next) {
        next(vm => {
                vm.state.api.subnav = []
        })
    },
    apollo: {
        readCompetitions: {
            // GraphQL query
            query: readCompetitionsQuery,
            // Will update the 'loading' attribute
            // +1 when a new query is loading
            // -1 when a query is completed
            loadingKey: 'loading',
            update(data) {
                console.log('competitions', data)
                return data.readCompetitions.edges
            }
        },
        readPageByURL: {
            // GraphQL query
            query: readPageQuery,
            variables() {
                return {
                    url: this.$route.path
                }
            },
            update(data) {
                return data.readOnePage
            },
            // manual: true,
            // result ({ data, loading }) {
            //     if (!loading) {
            //         this.page = data.readProjectByURLSegment
            //     }
            // },
            loadingKey: 'pageLoading'
        }
    }
}
</script>
